import TeamContainer from "../TeamContainer";
import { PageHeading } from "../Ui";
export default function TeamSelection() { return <><PageHeading title="Find your team." description="Your league identity starts here."/><section className="flow-panel"><p className="flow-help">Choose your Sleeper team. This link is permanent once saved, so make sure it's yours.</p><TeamContainer/></section></>; }
